<template>
  <section class="dp-layout mr-page-layout">
    <section class="dp-right mr-module mr-table-layout">
      <div class="page-header">
        <div>
          <div class="header-title-bar">
            <span class="header-icon-bar"></span>
            <h3>会议室管理</h3>
          </div>
          <p class="page-desc">维护会议室、开放时间、预约权限与班牌绑定</p>
        </div>
        <el-tag v-if="schoolName" type="success" size="medium" effect="plain" class="school-badge">
          <i class="el-icon-school"></i> {{ schoolName }}
        </el-tag>
        <span v-else-if="!schoolId" class="school-hint">请在顶部选择学校</span>
      </div>
      <toolbar v-if="schoolId" ref="roomToolbar" :buttonList="buttonList" @callFunction="callFunction"
        :searchList="toolbarSearchList">
        <el-button slot="buttonSlot" @click="resetFilters">重置</el-button>
      </toolbar>
      <div v-if="!schoolId" class="mr-empty">
        <div class="mr-empty__icon"><i class="el-icon-office-building"></i></div>
        <div class="mr-empty__text">请在顶部选择学校后管理会议室</div>
      </div>
      <template v-else>
            <el-table :data="tableData" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
        ref="table" class="custom-tbl mr-table" style="width: 100%"
        :row-class-name="roomRowClassName">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="Name" label="会议室名称" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.Name }}</span>
            <el-tag v-if="scope.row.Status === 1" type="danger" size="mini" effect="plain" style="margin-left: 6px;">维护中</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Location" label="地点" min-width="120"></el-table-column>
        <el-table-column prop="Capacity" label="容量" width="80"></el-table-column>
        <el-table-column prop="CampusName" label="校区" width="120"></el-table-column>
        <el-table-column label="开放预约" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsOpenForBooking ? 'success' : 'info'" size="small">
              {{ scope.row.IsOpenForBooking ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="需审批" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.RequireApproval ? 'warning' : 'info'" size="small">
              {{ scope.row.RequireApproval ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="绑定班牌" min-width="110" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.CplateBindingCount === 1" class="mr-cplate-single-name">
              {{ scope.row.CplateBindingPreview || '已绑定' }}
            </span>
            <el-button v-else-if="scope.row.CplateBindingCount > 1" type="text" size="mini"
              @click.stop="openCplateBindingPreview(scope.row)">
              {{ scope.row.CplateBindingCount }} 块
            </el-button>
            <span v-else class="mr-cplate-unbound">未绑定</span>
          </template>
        </el-table-column>
        <el-table-column prop="StatusStr" label="状态" width="80"></el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" width="170"></el-table-column>
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click.stop="showRoomQr(scope.row)">二维码</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :current-page="page" :page-size="pageSize" :total="total" style="float: right" />
      </el-col>
      </template>
      <el-dialog v-if="dialogVisible" :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false"
        destroy-on-close width="820px" top="5vh" custom-class="mr-module">
        <el-form v-if="dialogVisible" :model="form" label-width="120px" :rules="formRules" ref="form">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="基本信息" name="basic">
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="名称" prop="Name">
                    <el-input v-model="form.Name" placeholder="如：第一会议室"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="容量" prop="Capacity">
                    <el-input-number v-model="form.Capacity" :min="0" style="width: 100%;"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="地点">
                <el-input v-model="form.Location" placeholder="如：行政楼 3 楼"></el-input>
              </el-form-item>
              <el-form-item label="校区">
                <el-select v-model="form.CampusId" clearable filterable placeholder="请选择校区"
                  style="width: 100%;">
                  <el-option v-for="c in campusOptions" :key="c.id" :label="c.label" :value="c.id" />
                </el-select>
                <div v-if="!campusOptions.length" class="field-tip mr-field-tip">当前学校下暂无校区，可不选</div>
              </el-form-item>
              <el-form-item label="实景图片">
                <el-upload class="room-cover-uploader" name="Files" :action="BaseApiUrl + '/images/Upload/Pic'"
                  :show-file-list="false" :on-success="handleCoverSuccess" :before-upload="beforeCoverUpload">
                  <img v-if="form.CoverImage" v-oss-src="coverPreviewUrl" class="room-cover-img" />
                  <i v-else-if="!coverUploading" class="el-icon-plus room-cover-uploader-icon"></i>
                  <i v-else class="el-icon-loading room-cover-uploader-icon"></i>
                </el-upload>
                <el-button v-if="form.CoverImage" type="text" size="mini" @click="clearCover">清除图片</el-button>
              </el-form-item>
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="开放预约">
                    <el-switch v-model="form.IsOpenForBooking"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="需要审批">
                    <el-switch v-model="form.RequireApproval"></el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="8">
                  <el-form-item>
                    <template slot="label">
                      <span>最短时长</span>
                      <el-tooltip content="单次预约不得少于该分钟数（按 15 分钟步进）" placement="top">
                        <i class="el-icon-question field-label-tip"></i>
                      </el-tooltip>
                    </template>
                    <el-input-number v-model="form.MinDurationMinutes" :min="15" :step="15" style="width: 100%;"></el-input-number>
                    <div class="field-tip">单位：分钟</div>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item>
                    <template slot="label">
                      <span>最长时长</span>
                      <el-tooltip content="单次预约不得超过该分钟数" placement="top">
                        <i class="el-icon-question field-label-tip"></i>
                      </el-tooltip>
                    </template>
                    <el-input-number v-model="form.MaxDurationMinutes" :min="15" style="width: 100%;"></el-input-number>
                    <div class="field-tip">单位：分钟</div>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item>
                    <template slot="label">
                      <span>可提前预约</span>
                      <el-tooltip content="开始日期最远可选到今天起第 N 天（今天可约）" placement="top">
                        <i class="el-icon-question field-label-tip"></i>
                      </el-tooltip>
                    </template>
                    <el-input-number v-model="form.AdvanceBookingDays" :min="1" style="width: 100%;"></el-input-number>
                    <div class="field-tip">单位：天</div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="维护状态">
                <el-radio-group v-model="form.Status">
                  <el-radio :label="0">正常</el-radio>
                  <el-radio :label="1">维护中</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="绑定班牌">
                <el-select v-model="form.CplateTerminalIds" multiple filterable placeholder="选择班牌（可多选）"
                  style="width: 100%;">
                  <el-option v-for="item in cplateList" :key="item.Id"
                    :label="`${item.TerminalName || item.TerminalId} (${item.TerminalId})`"
                    :value="item.Id"></el-option>
                </el-select>
                <div class="field-tip mr-field-tip">一块班牌同时只绑一个会议室</div>
              </el-form-item>
              <el-form-item label="备注">
                <el-input v-model="form.Remark" type="textarea" :rows="2"></el-input>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="开放时间与权限" name="rule">
              <el-form-item label="开放时间">
                <div class="open-time-panel">
                  <div class="open-time-panel__header">
                    <div class="open-time-panel__mode">
                      <el-switch v-model="limitOpenTime" active-color="#1e3a8a"></el-switch>
                      <span class="open-time-panel__mode-text">{{ limitOpenTime ? '限制时段' : '全天开放' }}</span>
                      <span v-if="!limitOpenTime" class="open-time-panel__mode-desc">任意时间均可预约</span>
                    </div>
                    <div v-if="limitOpenTime" class="open-time-panel__actions">
                      <span v-if="openTimeRows.length" class="open-time-panel__count">共 {{ openTimeRows.length }} 条</span>
                      <el-button type="text" icon="el-icon-plus" @click="addOpenTimeRow">添加时段</el-button>
                    </div>
                  </div>

                  <div v-if="!limitOpenTime" class="open-time-panel__all-day">
                    <i class="el-icon-time"></i>
                    <span>未限制开放时段，全天均可预约</span>
                  </div>

                  <template v-else>
                    <div v-if="!openTimeRows.length" class="open-time-panel__empty">
                      <i class="el-icon-date"></i>
                      <p>尚未配置开放时段</p>
                      <span>可按星期分别设置可预约的开始与结束时间</span>
                      <el-button type="primary" plain size="small" icon="el-icon-plus"
                        @click="addOpenTimeRow">添加第一条时段</el-button>
                    </div>

                    <div v-else class="open-time-slots">
                      <div v-for="(row, index) in openTimeRows" :key="row._uid" class="open-time-slot">
                        <span class="open-time-slot__index">{{ index + 1 }}</span>
                        <el-select v-model="row.WeekDay" placeholder="星期" size="small"
                          class="open-time-slot__week">
                          <el-option v-for="w in weekOptions" :key="w.value" :label="w.label" :value="w.value" />
                        </el-select>
                        <el-time-select v-model="row.StartTime" :picker-options="timePickerOptions"
                          placeholder="开始" size="small" class="open-time-slot__time" />
                        <span class="open-time-slot__sep">至</span>
                        <el-time-select v-model="row.EndTime" :picker-options="timePickerOptions"
                          placeholder="结束" size="small" class="open-time-slot__time"
                          :min-time="row.StartTime" />
                        <el-button type="text" icon="el-icon-delete" class="open-time-slot__remove"
                          @click="removeOpenTimeRow(index)">删除</el-button>
                      </div>
                    </div>

                    <div class="open-time-panel__tip">
                      某星期未配置时段则当天不可预约；结束时间须晚于开始时间。
                    </div>
                  </template>
                </div>
              </el-form-item>
              <el-form-item label="预约权限">
                <el-radio-group v-model="permissionScope">
                  <el-radio label="all">{{ form.CampusId ? '本校区教职工可约' : '全校教职工可约' }}</el-radio>
                  <el-radio label="custom">指定部门/人员</el-radio>
                </el-radio-group>
                <div v-if="form.CampusId" class="field-tip mr-field-tip">会议室已绑定校区；指定部门时按部门及下级任教教师匹配</div>
              </el-form-item>
              <template v-if="permissionScope === 'custom'">
                <el-form-item label="可约部门">
                  <el-cascader v-model="permissionDeptId" :options="permissionDeptTreeOptions" change-on-select
                    :props="{ emitPath: false, value: 'value', label: 'label', children: 'children', expandTrigger: 'hover' }"
                    placeholder="请选择部门（选中节点及其全部下级）" clearable filterable style="width: 100%;" />
                </el-form-item>
                <el-form-item label="限定人员">
                  <MeetingRoomTeacherMultiSelect v-model="permissionTeacherIds"
                    :scope-department-id="permissionDeptId"
                    :scope-campus-id="form.CampusId"
                    :placeholder="permissionTeacherPlaceholder" />
                </el-form-item>
                <div class="permission-tip-row">
                  <span class="field-tip mr-field-tip">{{ permissionScopeTipText }}</span>
                  <el-button type="text" size="mini" :disabled="!permissionDeptId"
                    @click="openPermissionTeacherPreview">浏览可约人员</el-button>
                </div>
              </template>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm" :loading="submitLoading">保存</el-button>
        </div>
      </el-dialog>
      <MeetingRoomQrDialog
        v-if="qrVisible"
        :visible.sync="qrVisible"
        :loading="qrLoading"
        :qr-data="qrData"
        title="门牌二维码"
        download-prefix="门牌二维码" />

      <el-dialog title="预约权限预览" :visible.sync="permissionPreviewVisible" width="560px"
        append-to-body custom-class="mr-module mr-permission-preview-dialog" destroy-on-close>
        <div class="permission-preview-hero">
          <div class="permission-preview-hero__main">
            <span class="permission-preview-hero__icon"><i class="el-icon-office-building"></i></span>
            <div class="permission-preview-hero__text">
              <span class="permission-preview-hero__label">可约部门</span>
              <strong class="permission-preview-hero__dept">{{ permissionDeptLabel || '—' }}</strong>
            </div>
          </div>
          <el-tag size="small" effect="plain" :type="permissionLimitedMode ? 'warning' : 'success'">
            {{ permissionLimitedMode ? '限定人员' : '任教教师' }}
          </el-tag>
        </div>
        <p class="permission-preview-hint">
          {{ permissionPreviewHintText }}
        </p>

        <div class="permission-preview-panel">
          <div class="toolbar-filter-bar toolbar-filter-bar--embed permission-preview-panel__toolbar">
            <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent>
              <div class="toolbar-filter-fields">
                <el-form-item>
                  <span class="permission-preview-panel__title">
                    {{ permissionLimitedMode ? '限定名单' : '任教名单' }}
                    <em>{{ permissionPreviewDisplayCount }}</em>
                  </span>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="permissionPreviewKeyword" clearable
                    prefix-icon="el-icon-search" placeholder="姓名或部门" class="toolbar-field-w-md" />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="permission-preview-panel__body" v-loading="permissionPreviewLoading">
            <el-table v-if="permissionPreviewFilteredList.length" :data="permissionPreviewFilteredList"
              size="small" max-height="280" class="permission-preview-table">
              <el-table-column prop="TeacherName" label="姓名" min-width="96" />
              <el-table-column prop="DepartmentName" label="部门" min-width="140" show-overflow-tooltip />
            </el-table>
            <div v-else-if="!permissionPreviewLoading && !permissionPreviewList.length"
              class="permission-preview-empty">
              <i class="el-icon-user"></i>
              <p>{{ permissionLimitedMode ? '未选择限定人员' : '该部门及下级暂无任教教师' }}</p>
            </div>
            <div v-else-if="!permissionPreviewLoading" class="permission-preview-empty">
              <i class="el-icon-search"></i>
              <p>未找到匹配人员</p>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer permission-preview-footer">
          <el-button @click="permissionPreviewVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="绑定班牌" :visible.sync="cplateBindingVisible" width="520px"
        append-to-body custom-class="mr-module mr-cplate-binding-dialog" destroy-on-close>
        <div class="cplate-binding-hero">
          <span class="cplate-binding-hero__icon"><i class="el-icon-monitor"></i></span>
          <div class="cplate-binding-hero__text">
            <strong>{{ cplateBindingRoomName || '—' }}</strong>
            <span>已绑定 <em>{{ cplateBindingList.length }}</em> 块班牌</span>
          </div>
        </div>
        <div class="cplate-binding-panel" v-loading="cplateBindingLoading">
          <el-table v-if="cplateBindingList.length" :data="cplateBindingList" size="small"
            max-height="320" class="cplate-binding-table">
            <el-table-column type="index" label="#" width="48" />
            <el-table-column prop="TerminalName" label="班牌名称" min-width="140" show-overflow-tooltip />
            <el-table-column prop="TerminalId" label="终端标识" min-width="120" show-overflow-tooltip />
          </el-table>
          <div v-else-if="!cplateBindingLoading" class="cplate-binding-empty">
            <i class="el-icon-monitor"></i>
            <p>该会议室尚未绑定班牌</p>
            <p class="cplate-binding-empty__hint">可在编辑会议室的「班牌绑定」页签中配置</p>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cplateBindingVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>
<script>
import {
  getMeetingRoomListPage,
  getMeetingRoomDetail,
  addMeetingRoom,
  editMeetingRoom,
  deleteMeetingRoom,
  getCplateTerminalListPage,
  getCampusList,
  getDepartmentTree as getMeetingRoomDepartmentTree,
  getMeetingRoomQr,
  getMeetingRoomBoundCplates,
  BaseApiUrl
} from '../../api/meetingRoomApi';
import { getButtonList, getCachedButtonRouters } from '../../utils/routeButtonList';
import { fetchTeachingTeachersByDeptId } from '../../utils/meetingRoomTeacherCache';
import { normalizeOptionalId, toOptionalIdPayload } from '../../utils/meetingRoomForm';
import { resolveActiveSchoolId, normalizeDeptId, deptIdsEqual } from '../../utils/deptCascaderProps';
import Toolbar from '../../components/Toolbar';
export default {
  components: {
    Toolbar,
    MeetingRoomTeacherMultiSelect: () => import('../../components/MeetingRoomTeacherMultiSelect.vue'),
    MeetingRoomQrDialog: () => import('../../components/MeetingRoomQrDialog.vue')
  },
  data() {
    return {
      BaseApiUrl,
      filters: {},
      campusOptions: [],
      campusOptionsSchoolId: 0,
      buttonList: [],
      tableData: [],
      listLoading: false,
      viewMounted: false,
      pendingLoadAfterMount: false,
      loadListTimer: null,
      page: 1,
      pageSize: 10,
      total: 0,
      currentRow: null,
      departmentId: 0,
      dialogVisible: false,
      dialogTitle: '新增会议室',
      isEdit: false,
      submitLoading: false,
      activeTab: 'basic',
      cplateList: [],
      deptTreeOptions: [],
      limitOpenTime: false,
      openTimeRows: [],
      permissionScope: 'all',
      permissionDeptId: null,
      permissionTeacherIds: [],
      permissionPreviewVisible: false,
      permissionPreviewLoading: false,
      permissionPreviewList: [],
      permissionPreviewKeyword: '',
      coverUploading: false,
      qrVisible: false,
      qrLoading: false,
      qrData: null,
      cplateBindingVisible: false,
      cplateBindingLoading: false,
      cplateBindingList: [],
      cplateBindingRoomName: '',
      weekOptions: [
        { value: 1, label: '周一' }, { value: 2, label: '周二' }, { value: 3, label: '周三' },
        { value: 4, label: '周四' }, { value: 5, label: '周五' }, { value: 6, label: '周六' }, { value: 7, label: '周日' }
      ],
      timePickerOptions: {
        start: '06:00',
        step: '00:15',
        end: '23:45'
      },
      form: this.createEmptyForm(),
      formRules: {
        Name: [{ required: true, message: '请输入会议室名称', trigger: 'blur' }]
      }
    };
  },
  computed: {
    schoolId() {
      return resolveActiveSchoolId(this);
    },
    schoolName() {
      return this.$store.state.activeSchoolName || '';
    },
    coverPreviewUrl() {
      if (!this.form.CoverImage) return '';
      return this.$resolveImageSrc ? this.$resolveImageSrc(this.form.CoverImage) : this.form.CoverImage;
    },
    permissionDeptLabel() {
      if (!this.permissionDeptId) return '';
      return this.findDeptLabelInTree(this.permissionDeptTreeOptions, this.permissionDeptId)
        || this.findDeptLabelInTree(this.deptTreeOptions, this.permissionDeptId);
    },
    permissionDeptTreeOptions() {
      if (!this.form.CampusId) return this.deptTreeOptions;
      const campusNode = this.findSchoolNodeInTree(this.deptTreeOptions, this.form.CampusId);
      return campusNode ? [campusNode] : this.deptTreeOptions;
    },
    permissionLimitedMode() {
      return (this.permissionTeacherIds || []).length > 0;
    },
    permissionPreviewHintText() {
      if (this.permissionLimitedMode) return '已限定人员，仅以下人员可预约';
      return '已选部门（含全部下级），该范围内任教教师均可预约';
    },
    permissionScopeTipText() {
      return '选定部门及其全部下级部门的任教教师可约。可进一步限定具体人员。';
    },
    permissionTeacherPlaceholder() {
      if (!this.permissionDeptId) return '请先选择可约部门';
      return '不选则部门全员可约；选定后仅所选人员可约';
    },
    permissionPreviewFilteredList() {
      const kw = (this.permissionPreviewKeyword || '').trim().toLowerCase();
      const list = this.permissionPreviewList || [];
      if (!kw) return list;
      return list.filter(t => {
        const name = (t.TeacherName || '').toLowerCase();
        const dept = (t.DepartmentName || '').toLowerCase();
        return name.includes(kw) || dept.includes(kw);
      });
    },
    permissionPreviewDisplayCount() {
      const total = (this.permissionPreviewList || []).length;
      const shown = this.permissionPreviewFilteredList.length;
      const kw = (this.permissionPreviewKeyword || '').trim();
      if (kw && shown !== total) return `${shown} / ${total} 人`;
      return `${total} 人`;
    },
    /** 合并筛选条件与名称搜索，统一在 Toolbar 一行展示 */
    toolbarSearchList() {
      return [
        {
          label: '校区',
          key: 'campusId',
          type: 'select',
          clearable: true,
          width: '150px',
          options: this.campusOptions.map(c => ({ label: c.label, value: c.id }))
        },
        {
          label: '开放预约',
          key: 'isOpenForBooking',
          type: 'select',
          clearable: true,
          width: '150px',
          options: [
            { label: '已开放', value: 1 },
            { label: '未开放', value: 0 }
          ]
        },
        {
          label: '维护状态',
          key: 'status',
          type: 'select',
          clearable: true,
          width: '150px',
          options: [
            { label: '正常', value: 0 },
            { label: '维护中', value: 1 }
          ]
        },
        { label: '名称', key: 'name', width: '120px' }
      ];
    }
  },
  watch: {
    schoolId(val, oldVal) {
      if (val === oldVal) return;
      this.onMeetingSchoolChanged(val);
    },
    'form.CampusId'(val, oldVal) {
      if (val === oldVal || !this.dialogVisible) return;
      this.permissionDeptId = null;
      this.permissionTeacherIds = [];
    }
  },
  mounted() {
    this.viewMounted = true;
    this.initButtonListDeferred();
    if (this.schoolId) {
      this.loadCampusOptions();
      this.scheduleLoadList();
    } else if (this.pendingLoadAfterMount) {
      this.pendingLoadAfterMount = false;
      this.scheduleLoadList();
    }
  },
  activated() {
    if (this.schoolId && !this.tableData.length && !this.listLoading) {
      this.scheduleLoadList();
    }
  },
  beforeDestroy() {
    if (this.loadListTimer) {
      clearTimeout(this.loadListTimer);
      this.loadListTimer = null;
    }
  },
  methods: {
    initButtonListDeferred() {
      const applyButtons = () => {
        this.buttonList = getButtonList(this.$route.path, getCachedButtonRouters());
      };
      if (window.requestIdleCallback) {
        window.requestIdleCallback(applyButtons, { timeout: 800 });
      } else {
        setTimeout(applyButtons, 0);
      }
    },
    scheduleLoadList() {
      if (!this.schoolId) return;
      const pendingSchoolId = this.schoolId;
      if (this.loadListTimer) clearTimeout(this.loadListTimer);
      this.loadListTimer = setTimeout(() => {
        this.loadListTimer = null;
        if (pendingSchoolId === this.schoolId) {
          this.loadList();
        }
      }, 120);
    },
    createEmptyForm() {
      return {
        Id: 0,
        SchoolId: 0,
        CampusId: null,
        Name: '',
        Location: '',
        Capacity: 20,
        CoverImage: '',
        IsOpenForBooking: true,
        RequireApproval: false,
        MinDurationMinutes: 15,
        MaxDurationMinutes: 480,
        AdvanceBookingDays: 30,
        Status: 0,
        Remark: '',
        CplateTerminalIds: []
      };
    },
    normalizeCampusId(id) {
      return normalizeOptionalId(id);
    },
    onMeetingSchoolChanged(schoolId) {
      this.departmentId = schoolId || '';
      this.currentRow = null;
      this.page = 1;
      this.filters = {};
      this.campusOptions = [];
      this.campusOptionsSchoolId = 0;
      this.loadCampusOptions();
      if (!schoolId) {
        this.tableData = [];
        this.total = 0;
        this.pendingLoadAfterMount = false;
        return;
      }
      if (!this.viewMounted) {
        this.pendingLoadAfterMount = true;
        return;
      }
      this.scheduleLoadList();
    },
    resetFilters() {
      this.filters = {};
      const toolbar = this.$refs.roomToolbar;
      if (toolbar && toolbar.searchObj) {
        const selectKeys = new Set(
          (this.toolbarSearchList || []).filter(item => item.type === 'select').map(item => item.key)
        );
        Object.keys(toolbar.searchObj).forEach(key => {
          toolbar.searchObj[key] = selectKeys.has(key) ? null : '';
        });
      }
      this.page = 1;
      this.scheduleLoadList();
    },
    loadCampusOptions() {
      const schoolId = normalizeDeptId(this.schoolId);
      if (!schoolId) {
        this.campusOptions = [];
        this.campusOptionsSchoolId = 0;
        return Promise.resolve();
      }
      if (this.campusOptionsSchoolId === schoolId) return Promise.resolve();

      return getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then(res => {
        if (!deptIdsEqual(this.schoolId, schoolId)) return;
        if (!res.data.success) {
          this.campusOptions = [];
          return;
        }
        const response = res.data.response || {};
        const rows = Array.isArray(response.data) ? response.data : [];
        this.campusOptions = rows.map(item => ({
          id: Number(item.Id || item.id),
          label: item.Name || item.name || ''
        })).filter(item => item.id > 0);
        this.campusOptionsSchoolId = schoolId;
      }).catch(() => {
        if (deptIdsEqual(this.schoolId, schoolId)) {
          this.campusOptions = [];
          this.campusOptionsSchoolId = 0;
        }
      });
    },
    callFunction(item) {
      if (typeof item.search === 'object') {
        this.filters = { ...item.search };
        if ('campusId' in this.filters) {
          this.filters.campusId = normalizeOptionalId(this.filters.campusId);
        }
      } else {
        this.filters = { name: item.search };
      }
      this[item.Func].apply(this, item);
    },
    dialogCheck(selection, row) {
      this.currentRow = row;
    },
    selectCurrentRow(row) {
      this.currentRow = row;
      this.$refs.table.clearSelection();
      this.$refs.table.toggleRowSelection(row, true);
    },
    handleQuery() {
      this.page = 1;
      this.scheduleLoadList();
    },
    handleAdd() {
      this.openDialog(false);
    },
    handleEdit() {
      this.openDialog(true);
    },
    handleDel() {
      this.handleDelete();
    },
    handleCurrentChange(val) {
      const nextPage = Number(val);
      if (!nextPage || nextPage === this.page) return;
      this.page = nextPage;
      this.scheduleLoadList();
    },
    loadList() {
      if (!this.schoolId) return;
      this.listLoading = true;
      const para = {
        page: this.page,
        intPageSize: this.pageSize,
        departmentId: this.schoolId,
        name: this.filters.name || '',
        campusId: toOptionalIdPayload(this.filters.campusId),
        isOpenForBooking: this.filters.isOpenForBooking != null && this.filters.isOpenForBooking !== ''
          ? this.filters.isOpenForBooking
          : undefined,
        status: this.filters.status != null && this.filters.status !== ''
          ? this.filters.status
          : undefined
      };
      getMeetingRoomListPage(para).then(res => {
        this.listLoading = false;
        if (res.data.success) {
          this.tableData = res.data.response.data || [];
          this.total = res.data.response.dataCount || 0;
        }
      }).catch(() => { this.listLoading = false; });
    },
    loadCplateList() {
      if (!this.schoolId) return;
      getCplateTerminalListPage({ page: 1, intPageSize: 200, departmentId: this.schoolId }).then(res => {
        if (res.data.success) {
          this.cplateList = res.data.response.data || [];
        }
      });
    },
    loadDialogOptions() {
      this.loadCplateList();
      this.loadCampusOptions();
      this.loadDeptOptions();
    },
    loadDeptOptions() {
      if (!this.schoolId) {
        this.deptTreeOptions = [];
        return;
      }
      getMeetingRoomDepartmentTree({ pid: 0 }).then(res => {
        if (!res.data.success) return;
        const root = res.data.response;
        const schoolNode = this.findSchoolNodeInTree(root, this.schoolId);
        this.deptTreeOptions = schoolNode ? [schoolNode] : [];
      });
    },
    /** 从完整部门树中定位当前学校节点（与班级通知一致） */
    findSchoolNodeInTree(nodes, schoolId) {
      const list = Array.isArray(nodes) ? nodes : (nodes ? [nodes] : []);
      const targetId = normalizeDeptId(schoolId);
      for (const node of list) {
        const nodeId = Number(node.value != null ? node.value : node.Id);
        if (nodeId === targetId) return node;
        if (node.children && node.children.length) {
          const found = this.findSchoolNodeInTree(node.children, schoolId);
          if (found) return found;
        }
      }
      return null;
    },
    findDeptLabelInTree(nodes, id, visited = new Set()) {
      const targetId = String(id);
      for (const node of nodes || []) {
        const nodeId = node.value != null ? node.value : node.Id;
        const sid = String(nodeId);
        if (sid === targetId) return node.label || node.Name || node.title || '';
        if (visited.has(sid)) continue;
        if (nodeId) visited.add(sid);
        const childLabel = this.findDeptLabelInTree(node.children, id, visited);
        if (childLabel) return childLabel;
      }
      return '';
    },
    openPermissionTeacherPreview() {
      if (!this.permissionDeptId) {
        this.$message.warning('请先选择可约部门');
        return;
      }
      this.permissionPreviewVisible = true;
      this.permissionPreviewLoading = true;
      this.permissionPreviewList = [];
      this.permissionPreviewKeyword = '';
      const limitedIds = (this.permissionTeacherIds || []).map(id => String(id));
      fetchTeachingTeachersByDeptId(this.permissionDeptId, this.form.CampusId).then(deptRows => {
        const deptList = deptRows || [];
        if (!limitedIds.length) {
          this.permissionPreviewLoading = false;
          this.permissionPreviewList = deptList;
          return;
        }
        const teacherMap = new Map(deptList.map(t => [String(t.Id), t]));
        this.permissionPreviewLoading = false;
        this.permissionPreviewList = limitedIds.map(id => {
          const hit = teacherMap.get(id);
          return hit || { Id: id, TeacherName: `教职工(${id})`, DepartmentName: '' };
        });
      }).catch(() => {
        this.permissionPreviewLoading = false;
        this.$message.error('加载可约人员失败');
      });
    },
    resetRuleFields() {
      this.limitOpenTime = false;
      this.openTimeRows = [];
      this.permissionScope = 'all';
      this.permissionDeptId = null;
      this.permissionTeacherIds = [];
      this.activeTab = 'basic';
    },
    applyDetailRules(openTimes, permissions) {
      const times = openTimes || [];
      this.limitOpenTime = times.length > 0;
      this.openTimeRows = times.map(t => this.createOpenTimeRow(
        t.WeekDay,
        this.normalizeTimeStr(t.StartTime),
        this.normalizeTimeStr(t.EndTime)
      ));
      const perms = permissions || [];
      const hasAll = !perms.length || perms.some(p => p.TargetType === 0);
      if (hasAll) {
        this.permissionScope = 'all';
        this.permissionDeptId = null;
        this.permissionTeacherIds = [];
      } else {
        this.permissionScope = 'custom';
        const deptPerms = perms.filter(p => p.TargetType === 1);
        this.permissionDeptId = deptPerms.length
          ? normalizeOptionalId(deptPerms[0].TargetId)
          : null;
        this.permissionTeacherIds = perms
          .filter(p => p.TargetType === 2)
          .map(p => p.TargetId)
          .filter(id => Number(id) > 0);
      }
    },
    normalizeTimeStr(val) {
      if (!val) return '08:00';
      const s = String(val);
      return s.length >= 5 ? s.slice(0, 5) : s;
    },
    createOpenTimeRow(weekDay = 1, startTime = '08:00', endTime = '18:00') {
      return {
        _uid: `ot-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        WeekDay: weekDay,
        StartTime: startTime,
        EndTime: endTime
      };
    },
    addOpenTimeRow() {
      this.openTimeRows.push(this.createOpenTimeRow());
    },
    removeOpenTimeRow(index) {
      this.openTimeRows.splice(index, 1);
    },
    buildOpenTimesPayload() {
      if (!this.limitOpenTime) return [];
      return this.openTimeRows
        .filter(r => r.WeekDay && r.StartTime && r.EndTime)
        .map(r => ({
          WeekDay: r.WeekDay,
          StartTime: r.StartTime,
          EndTime: r.EndTime
        }));
    },
    buildPermissionsPayload() {
      if (this.permissionScope === 'all') return [];
      const list = [];
      const teacherIds = this.permissionTeacherIds || [];
      if (teacherIds.length > 0) {
        teacherIds.forEach(id => {
          list.push({ TargetType: 2, TargetId: id, TargetName: '' });
        });
        // 保留部门用于编辑回显；存在人员权限时后端仅校验人员
        if (this.permissionDeptId) {
          list.push({
            TargetType: 1,
            TargetId: this.permissionDeptId,
            TargetName: this.permissionDeptLabel
          });
        }
      } else if (this.permissionDeptId) {
        list.push({
          TargetType: 1,
          TargetId: this.permissionDeptId,
          TargetName: this.permissionDeptLabel
        });
      }
      return list;
    },
    validateRuleTab() {
      if (this.limitOpenTime) {
        if (!this.openTimeRows.length) {
          this.$message.warning('请至少添加一条开放时段，或关闭「限制时段」');
          this.activeTab = 'rule';
          return false;
        }
        const invalid = this.openTimeRows.some(r => !r.WeekDay || !r.StartTime || !r.EndTime || r.EndTime <= r.StartTime);
        if (invalid) {
          this.$message.warning('请检查开放时段：结束时间须晚于开始时间');
          this.activeTab = 'rule';
          return false;
        }
      }
      if (this.permissionScope === 'custom') {
        if (!this.permissionDeptId) {
          this.$message.warning('请选择一个可约部门');
          this.activeTab = 'rule';
          return false;
        }
      }
      return true;
    },
    handleCoverSuccess(res) {
      this.coverUploading = false;
      if (res && res.response) {
        this.form.CoverImage = res.response;
      } else {
        this.$message.error('图片上传失败');
      }
    },
    beforeCoverUpload() {
      this.coverUploading = true;
      return true;
    },
    clearCover() {
      this.form.CoverImage = '';
    },
    showRoomQr(row) {
      if (!row || !row.Id) return;
      this.qrVisible = true;
      this.qrLoading = true;
      this.qrData = null;
      getMeetingRoomQr(row.Id).then(res => {
        this.qrLoading = false;
        if (res.data.success) {
          this.qrData = res.data.response || null;
        } else {
          this.$message.error(res.data.msg || '获取二维码失败');
          this.qrVisible = false;
        }
      }).catch(() => {
        this.qrLoading = false;
        this.qrVisible = false;
        this.$message.error('获取二维码失败');
      });
    },
    /** 查看会议室已绑定班牌列表 */
    openCplateBindingPreview(row) {
      if (!row || !row.Id) return;
      this.cplateBindingVisible = true;
      this.cplateBindingLoading = true;
      this.cplateBindingList = [];
      this.cplateBindingRoomName = row.Name || '';
      getMeetingRoomBoundCplates(row.Id).then(res => {
        this.cplateBindingLoading = false;
        if (res.data.success) {
          this.cplateBindingList = res.data.response || [];
        } else {
          this.$message.error(res.data.msg || '加载班牌列表失败');
        }
      }).catch(() => {
        this.cplateBindingLoading = false;
        this.$message.error('加载班牌列表失败');
      });
    },
    openDialog(isEdit) {
      if (!this.schoolId) {
        this.$message.warning('请先选择左侧学校/校区');
        return;
      }
      this.isEdit = isEdit;
      this.dialogTitle = isEdit ? '编辑会议室' : '新增会议室';
      this.resetRuleFields();
      this.loadDialogOptions();
      if (isEdit) {
        if (!this.currentRow) {
          this.$message.warning('请选择一条记录');
          return;
        }
        getMeetingRoomDetail(this.currentRow.Id).then(res => {
          if (!res.data.success) {
            this.$message.error(res.data.msg || '加载失败');
            return;
          }
          const detail = res.data.response;
          const room = detail.Room || {};
          this.form = {
            Id: room.Id,
            SchoolId: room.SchoolId,
            CampusId: this.normalizeCampusId(room.CampusId),
            Name: room.Name,
            Location: room.Location,
            Capacity: room.Capacity,
            CoverImage: room.CoverImage || '',
            IsOpenForBooking: room.IsOpenForBooking,
            RequireApproval: room.RequireApproval,
            MinDurationMinutes: room.MinDurationMinutes,
            MaxDurationMinutes: room.MaxDurationMinutes,
            AdvanceBookingDays: room.AdvanceBookingDays,
            Status: room.Status,
            Remark: room.Remark,
            CplateTerminalIds: (detail.BoundCplateTerminals || []).map(b => b.CplateTerminalId)
          };
          this.applyDetailRules(detail.OpenTimes, detail.Permissions);
          this.dialogVisible = true;
        });
      } else {
        this.form = this.createEmptyForm();
        this.form.SchoolId = this.schoolId;
        this.form.CampusId = this.normalizeCampusId(this.filters.campusId);
        if (!this.form.CampusId && this.campusOptions.length === 1) {
          this.form.CampusId = this.campusOptions[0].id;
        }
        this.dialogVisible = true;
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          this.activeTab = 'basic';
          return;
        }
        if (!this.validateRuleTab()) return;
        this.submitLoading = true;
        const payload = {
          ...this.form,
          CampusId: toOptionalIdPayload(this.form.CampusId),
          OpenTimes: this.buildOpenTimesPayload(),
          Permissions: this.buildPermissionsPayload()
        };
        const api = this.isEdit ? editMeetingRoom : addMeetingRoom;
        api(payload).then(res => {
          this.submitLoading = false;
          if (res.data.success) {
            this.$message.success(res.data.msg || '保存成功');
            this.dialogVisible = false;
            this.loadList();
          } else {
            this.$message.error(res.data.msg || '保存失败');
          }
        }).catch(() => { this.submitLoading = false; });
      });
    },
    handleDelete() {
      if (!this.currentRow) {
        this.$message.warning('请选择一条记录');
        return;
      }
      this.$confirm('确认删除该会议室？', '提示', { type: 'warning' }).then(() => {
        deleteMeetingRoom(this.currentRow.Id).then(res => {
          if (res.data.success) {
            this.$message.success('删除成功');
            this.loadList();
          } else {
            this.$message.error(res.data.msg || '删除失败');
          }
        });
      }).catch(() => {});
    },
    roomRowClassName({ row }) {
      if (row && row.Status === 1) return 'mr-room-row--maintenance';
      if (row && !row.IsOpenForBooking) return 'mr-room-row--closed';
      return '';
    }
  }
};
</script>
<style scoped>
.field-tip {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}
.field-label-tip {
  margin-left: 4px;
  color: #c0c4cc;
  cursor: help;
  font-size: 14px;
  vertical-align: middle;
}
.field-label-tip:hover {
  color: var(--btn-primary, #2563eb);
}
.open-time-panel {
  width: 100%;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: linear-gradient(180deg, #f8fbff 0%, #fff 100%);
  overflow: hidden;
}
.open-time-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-bottom: 1px solid #e8f0fe;
  background: rgba(255, 255, 255, 0.85);
  gap: 8px;
}
.open-time-panel__count {
  font-size: 12px;
  color: #64748b;
}
.open-time-panel__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.open-time-panel__mode {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.open-time-panel__mode-text {
  font-size: 13px;
  font-weight: 600;
  color: #1e3a8a;
}
.open-time-panel__mode-desc {
  font-size: 12px;
  color: #64748b;
}
.open-time-panel__all-day {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 20px 16px;
  color: #059669;
  font-size: 13px;
}
.open-time-panel__all-day i {
  font-size: 18px;
}
.open-time-panel__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 16px 24px;
  text-align: center;
}
.open-time-panel__empty i {
  font-size: 32px;
  color: #93c5fd;
  margin-bottom: 8px;
}
.open-time-panel__empty p {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
}
.open-time-panel__empty span {
  margin-bottom: 14px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}
.open-time-slots {
  padding: 10px 12px 4px;
  max-height: 280px;
  overflow-y: auto;
}
.open-time-slots::-webkit-scrollbar {
  width: 6px;
}
.open-time-slots::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
.open-time-slots::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.open-time-slot {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.open-time-slot:hover {
  border-color: #93c5fd;
  box-shadow: 0 2px 8px rgba(30, 58, 138, 0.06);
}
.open-time-slot__index {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 50%;
  background: #eff6ff;
  color: #1e3a8a;
  font-size: 12px;
  font-weight: 600;
}
.open-time-slot__week {
  width: 96px;
}
.open-time-slot__time {
  width: 108px;
}
.open-time-slot__sep {
  color: #94a3b8;
  font-size: 12px;
}
.open-time-slot__remove {
  margin-left: auto;
  color: #94a3b8;
  padding: 4px 6px;
}
.open-time-slot__remove:hover {
  color: #dc2626;
}
.open-time-panel__tip {
  padding: 8px 14px 12px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
  border-top: 1px dashed #e2e8f0;
}
.permission-tip-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 8px;
}
.permission-tip-row .field-tip {
  margin-top: 0;
}
.permission-preview-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%);
  border: 1px solid #dbeafe;
}
.permission-preview-hero__main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.permission-preview-hero__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #fff;
  color: #1e3a8a;
  font-size: 20px;
  box-shadow: 0 2px 8px rgba(30, 58, 138, 0.08);
}
.permission-preview-hero__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.permission-preview-hero__label {
  font-size: 12px;
  color: #64748b;
}
.permission-preview-hero__dept {
  font-size: 15px;
  font-weight: 600;
  color: #1e3a8a;
  word-break: break-all;
}
.permission-preview-hint {
  margin: 10px 0 14px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}
.permission-preview-panel {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}
.permission-preview-panel__toolbar.toolbar-filter-bar--embed {
  margin: 0;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: none;
  background: #f8fafc;
}
.permission-preview-panel__title {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
  line-height: 32px;
}
.permission-preview-panel__title em {
  margin-left: 4px;
  font-style: normal;
  font-weight: normal;
  color: #64748b;
}
.permission-preview-panel__body {
  min-height: 120px;
  padding: 0;
}
.permission-preview-table {
  width: 100%;
}
.permission-preview-table >>> th.el-table__cell {
  background: #f8fafc !important;
  color: #475569;
  font-weight: 600;
}
.permission-preview-table >>> td.el-table__cell {
  border-bottom: 1px solid #f1f5f9;
}
.permission-preview-table >>> .el-table__body tr:hover > td {
  background: #f8fbff !important;
}
.permission-preview-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 36px 16px;
  text-align: center;
  color: #94a3b8;
}
.permission-preview-empty i {
  font-size: 28px;
  margin-bottom: 8px;
  color: #cbd5e1;
}
.permission-preview-empty p {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}
.permission-preview-footer {
  padding-top: 4px;
}
.mr-cplate-unbound {
  font-size: 13px;
  color: #94a3b8;
}
.mr-cplate-single-name {
  font-size: 13px;
  color: #334155;
}
.cplate-binding-hero {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  margin-bottom: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.cplate-binding-hero__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #e0f2fe;
  color: #0284c7;
  font-size: 20px;
}
.cplate-binding-hero__text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.cplate-binding-hero__text strong {
  font-size: 15px;
  color: #0f172a;
}
.cplate-binding-hero__text span {
  font-size: 13px;
  color: #64748b;
}
.cplate-binding-hero__text em {
  font-style: normal;
  font-weight: 600;
  color: #0284c7;
}
.cplate-binding-panel {
  min-height: 120px;
}
.cplate-binding-table >>> th.el-table__cell {
  background: #f8fafc;
  color: #475569;
  font-weight: 600;
}
.cplate-binding-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 32px 16px;
  color: #94a3b8;
}
.cplate-binding-empty i {
  font-size: 36px;
}
.cplate-binding-empty p {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}
.cplate-binding-empty__hint {
  font-size: 12px !important;
  color: #94a3b8 !important;
}
.room-cover-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 148px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.room-cover-uploader >>> .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}
.room-cover-img {
  width: 148px;
  height: 100px;
  object-fit: cover;
  display: block;
}
.room-cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}
.mr-room-row--maintenance >>> td {
  background-color: #fef2f2 !important;
}
.mr-room-row--closed >>> td {
  background-color: #f8fafc !important;
}
</style>
